(function() {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════
     APPAREL PRODUCT — Variant-Based Image Filtering (Filename Match)
     ═══════════════════════════════════════════════════════════════
     HOW IT WORKS:
     - Each image has data-image-filename (e.g. "black2.jpg", "red1.png")
     - When a color variant is selected (e.g. "Red"), we normalize it
       to "red" and check if each filename STARTS WITH that color.
     - "black2.jpg" starts with "black" → belongs to Black
     - "reddress.png" starts with "red" → belongs to Red
     - "grey1.jpg" starts with "grey" → belongs to Grey
     - "lightgrey3.jpg" starts with "lightgrey" → belongs to Light Grey

     NAMING RULE:
     Just name your images starting with the color name:
       Red 1.jpg, Red 2.jpg, Black 1.jpg, Grey Dress.jpg
     Shopify converts spaces/special chars, so "Red 1.jpg" → "red_1.jpg"
     The code handles all these normalizations automatically.
     ═══════════════════════════════════════════════════════════════ */

  /* XHR-based cart add — bypasses Dawn's fetch() interceptor that causes duplicates */
  function cozyRenderSavings(cart) {
    var totalRow = document.querySelector('.apparel-cart-drawer__total');
    if (!totalRow) return;
    var el = document.getElementById('cozy-cart-savings');
    if (!cart || !cart.total_discount) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.id = 'cozy-cart-savings';
      el.style.cssText = 'display:flex;justify-content:space-between;align-items:center;font-size:13px;font-weight:700;color:#2E7D4F;margin:0 0 6px;';
      totalRow.parentNode.insertBefore(el, totalRow);
    }
    el.innerHTML = '<span>You\'re saving</span><span>' + formatMoney(cart.total_discount) + '</span>';
  }

  /* Show the compare-at ("was") price on every drawer line plus the real
     order-level saving. Reuses fetchProductData's cache, so no extra requests. */
  function cozyEnhanceComparePrices(cart) {
    var cleanup = function() {
      var e0 = document.getElementById('cozy-total-cmp'); if (e0) e0.remove();
      var s0 = document.getElementById('cozy-cmp-saveline'); if (s0) s0.remove();
    };
    if (!cart || !cart.items || !cart.items.length) { cleanup(); return; }
    Promise.all(cart.items.map(function(it) {
      return it.handle ? fetchProductData(it.handle).catch(function() { return null; }) : Promise.resolve(null);
    })).then(function(products) {
      var cmpTotal = 0, anyCmp = false;
      cart.items.forEach(function(item, i) {
        var p = products[i], cmpCents = 0;
        if (p && p.variants) {
          for (var v = 0; v < p.variants.length; v++) {
            if (String(p.variants[v].id) === String(item.variant_id)) {
              var c = Math.round(parseFloat(p.variants[v].compare_at_price || 0) * 100);
              var pr = Math.round(parseFloat(p.variants[v].price || 0) * 100);
              if (c > pr) cmpCents = c;
              break;
            }
          }
        }
        var lineCmp = cmpCents > 0 ? cmpCents * item.quantity : item.final_line_price;
        cmpTotal += lineCmp;
        if (cmpCents > 0) anyCmp = true;
        var row = cartLineItems.querySelector('.apparel-cart-item[data-key="' + item.key + '"]');
        if (!row) return;
        var priceEl = row.querySelector('.apparel-cart-item__price');
        if (!priceEl || priceEl.classList.contains('apparel-cart-item__price--free')) return;
        if (cmpCents > 0 && cmpCents * item.quantity > item.final_line_price) {
          /* 🔒 2026-09-06 (TA): the % badge is pinned to the REGULAR price, so a line carrying the Buy 1 Get 1 discount
             still reads "50% OFF" like its sibling; the green 🎁 line under the price carries the extra 25%. */
          var cozyHasLineDisc = !!(item.line_level_discount_allocations && item.line_level_discount_allocations.some(function(d){ return d.amount > 0; }));
          var cozyPctBase = cozyHasLineDisc ? item.original_line_price : item.final_line_price;
          var pct = Math.round(100 - (cozyPctBase / (cmpCents * item.quantity)) * 100);
          priceEl.innerHTML = '<s class="cozy-cmp-strike">' + formatMoney(cmpCents * item.quantity) + '</s>' +
            '<span class="cozy-price-now">' + formatMoney(item.final_line_price) + '</span>' +
            (pct > 0 ? '<span class="cozy-pct-chip">' + pct + '% OFF</span>' : '');
        }
      });
      var totalStrong = document.getElementById('apparel-cart-total');
      var totalRow = document.querySelector('.apparel-cart-drawer__total');
      var cmpEl = document.getElementById('cozy-total-cmp');
      if (anyCmp && cmpTotal > cart.total_price) {
        if (!cmpEl && totalStrong) {
          cmpEl = document.createElement('s');
          cmpEl.id = 'cozy-total-cmp';
          totalStrong.parentNode.insertBefore(cmpEl, totalStrong);
        }
        if (cmpEl) cmpEl.textContent = formatMoney(cmpTotal);
        var save = document.getElementById('cozy-cmp-saveline');
        if (!save && totalRow) {
          save = document.createElement('div');
          save.id = 'cozy-cmp-saveline';
          totalRow.parentNode.insertBefore(save, totalRow.nextSibling);
        }
        if (save) save.innerHTML = 'You\'re saving <strong>' + formatMoney(cmpTotal - cart.total_price) + '</strong> on this order';
        /* This line already includes any code discount, so drop the discount-only row */
        var dup = document.getElementById('cozy-cart-savings'); if (dup) dup.remove();
      } else {
        cleanup();
      }
    });
  }

  function xhrCartAdd(variantId, qty, props) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject(new Error('Cart add failed: ' + xhr.status));
        }
      };
      xhr.onerror = function() { reject(new Error('Cart add network error')); };
      var cozyItem = { id: variantId, quantity: qty };
      if (props && Object.keys(props).length) cozyItem.properties = props;
      xhr.send(JSON.stringify({ items: [cozyItem] }));
    });
  }

  var productJSON = document.getElementById('apparel-product-json');
  /* SITE-WIDE: don't bail on non-product pages — the cart drawer code below works without
     a product. Only product-specific features (gallery, variant filter, ATC) will skip. */
  var product = productJSON ? JSON.parse(productJSON.textContent) : null;
  var variants = product ? product.variants : [];

  /* DOM references */
  var form = document.getElementById('apparel-product-form');
  var variantSelect = document.getElementById('apparel-variant-select');
  var atcBtn = document.getElementById('apparel-atc-btn');
  var atcText = document.getElementById('apparel-atc-text');
  var priceBlock = document.getElementById('apparel-price');
  var stickyBar = document.getElementById('apparel-sticky-bar');
  var stickyAtc = document.getElementById('apparel-sticky-atc');
  var galleryMain = document.getElementById('apparel-gallery-main');
  var thumbnails = document.getElementById('apparel-thumbnails');
  var dotsContainer = document.getElementById('apparel-gallery-dots');
  var cartDrawer = document.getElementById('apparel-cart-drawer');
  var cartOverlay = document.getElementById('apparel-cart-overlay');
  var cartClose = document.getElementById('apparel-cart-close');
  var cartLineItems = document.getElementById('apparel-cart-items');
  var cartEmpty = document.getElementById('apparel-cart-empty');
  var cartFooter = document.getElementById('apparel-cart-footer');
  var cartTotal = document.getElementById('apparel-cart-total');
  var cartUpsells = document.getElementById('apparel-cart-upsells');
  var cartUpsellItems = document.getElementById('apparel-cart-upsell-items');
  var cartScroll = document.getElementById('apparel-cart-scroll');
  var prevArrow = document.getElementById('apparel-gallery-prev');
  var nextArrow = document.getElementById('apparel-gallery-next');

  /* Presentment-currency formatter — /cart.js returns converted cents; never hardcode $ or a currency suffix (TA 2026-08-12) */
  var NF_CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: NF_CURRENCY }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Detect which option index is "Color" */
  var colorOptionIndex = -1;
  if (product && product.options) {
    for (var oi = 0; oi < product.options.length; oi++) {
      var optName = (product.options[oi] || '').toLowerCase().trim();
      if (optName === 'color' || optName === 'colour') { colorOptionIndex = oi; break; }
    }
  }

  /* Collect all color values from variants for smart matching */
  var allColorValues = [];
  if (colorOptionIndex >= 0) {
    var seen = {};
    variants.forEach(function(v) {
      var c = v['option' + (colorOptionIndex + 1)];
      if (c && !seen[c]) { seen[c] = true; allColorValues.push(c); }
    });
  }

  var currentColorFilter = null;
  var currentVisibleImages = [];
  var currentVisibleThumbs = [];
  var currentSlideIndex = 0;

  /* ═══════════════════════════════════════════
     FILENAME-BASED COLOR MATCHING
     ═══════════════════════════════════════════
     Normalize a color name to a clean lowercase
     string with no spaces/hyphens/underscores,
     then check if a filename starts with it.

     "Red" → "red"
     "Light Grey" → "lightgrey"
     "Navy Blue" → "navyblue"

     Filename "black2.jpg" → strip to "black2"
     Does "black2" start with "black"? YES
     ═══════════════════════════════════════════ */
  function normalizeForMatch(str) {
    return (str || '').toLowerCase().replace(/[\s\-_]+/g, '');
  }

  function filenameMatchesColor(filename, colorValue) {
    /* Strip extension from filename */
    var fnameClean = normalizeForMatch(filename.replace(/\.[^.]+$/, ''));
    var colorClean = normalizeForMatch(colorValue);
    if (!fnameClean || !colorClean) return false;
    return fnameClean.indexOf(colorClean) === 0;
  }

  function altMatchesColor(el, colorValue) {
    var alt = (el.getAttribute('data-image-alt') || '').toLowerCase().trim();
    var color = (colorValue || '').toLowerCase().trim();
    if (!alt || !color) return false;
    return alt.indexOf(color) !== -1;
  }

  function imageMatchesColor(el, colorValue) {
    /* Universal slides (e.g. the product video) apply to every color — never hide them. */
    if (el.getAttribute('data-universal') === 'true') return true;
    /* Try alt text first (more reliable), fall back to filename */
    if (altMatchesColor(el, colorValue)) return true;
    var fn = el.getAttribute('data-image-filename') || '';
    return filenameMatchesColor(fn, colorValue);
  }

  /* ═══════════════════════════════════════════
     IMAGE FILTERING BY COLOR
     ═══════════════════════════════════════════ */
  function filterGalleryByColor(colorValue) {
    if (!galleryMain || !thumbnails) return;
    if (!colorValue) { showAllImages(); return; }

    /* Skip if the color hasn't changed — prevents gallery reset on size change */
    if (currentColorFilter && currentColorFilter.toLowerCase() === colorValue.toLowerCase()) return;

    currentColorFilter = colorValue;

    /* Reorder DOM: move matching images to the FRONT of the gallery */
    var allImages = Array.from(galleryMain.querySelectorAll('.apparel-product__gallery-image'));
    var allThumbs = Array.from(thumbnails.querySelectorAll('.apparel-product__thumbnail'));

    /* Separate matching and non-matching images */
    var matchingImages = [];
    var otherImages = [];
    allImages.forEach(function(img) {
      if (imageMatchesColor(img, colorValue)) matchingImages.push(img);
      else otherImages.push(img);
    });

    /* Reorder gallery: matching first, then the rest */
    matchingImages.forEach(function(img) { galleryMain.appendChild(img); });
    otherImages.forEach(function(img) { galleryMain.appendChild(img); });

    /* Do the same for thumbnails */
    var matchingThumbs = [];
    var otherThumbs = [];
    allImages.forEach(function(img, idx) {
      /* Find the thumbnail with same data-index as this image */
      var imgIndex = img.getAttribute('data-index');
      var matchThumb = null;
      for (var t = 0; t < allThumbs.length; t++) {
        if (allThumbs[t].getAttribute('data-index') === imgIndex) {
          matchThumb = allThumbs[t];
          break;
        }
      }
      if (matchThumb) {
        if (imageMatchesColor(img, colorValue)) matchingThumbs.push(matchThumb);
        else otherThumbs.push(matchThumb);
      }
    });
    matchingThumbs.forEach(function(thumb) { thumbnails.appendChild(thumb); });
    otherThumbs.forEach(function(thumb) { thumbnails.appendChild(thumb); });

    /* Hide non-matching images and thumbs; keep only the selected color visible. */
    currentVisibleImages = [];
    matchingImages.forEach(function(img) {
      img.style.display = '';
      img.classList.remove('apparel-product__gallery-image--hidden');
      currentVisibleImages.push(img);
    });
    otherImages.forEach(function(img) {
      img.style.display = 'none';
      img.classList.add('apparel-product__gallery-image--hidden');
    });

    currentVisibleThumbs = [];
    matchingThumbs.forEach(function(thumb) {
      thumb.style.display = '';
      thumb.classList.remove('apparel-product__thumbnail--hidden');
      currentVisibleThumbs.push(thumb);
    });
    otherThumbs.forEach(function(thumb) {
      thumb.style.display = 'none';
      thumb.classList.add('apparel-product__thumbnail--hidden');
    });

    /* Safety net: if NO images matched (e.g. alt text missing), show everything
       so the user isn't left with an empty gallery. */
    if (matchingImages.length === 0) {
      showAllImages();
      return;
    }

    /* Scroll to the very first visible (matching-color) image */
    currentSlideIndex = 0;
    requestAnimationFrame(function() {
      scrollToVisibleIndex(0, false);
      highlightVisibleThumb(0);
      buildDots();
      updateArrowState();
    });
  }

  function showAllImages(allImages, allThumbs) {
    if (!allImages) allImages = galleryMain ? galleryMain.querySelectorAll('.apparel-product__gallery-image') : [];
    if (!allThumbs) allThumbs = thumbnails ? thumbnails.querySelectorAll('.apparel-product__thumbnail') : [];

    currentVisibleImages = [];
    for (var i = 0; i < allImages.length; i++) {
      allImages[i].style.display = '';
      allImages[i].classList.remove('apparel-product__gallery-image--hidden');
      currentVisibleImages.push(allImages[i]);
    }
    currentVisibleThumbs = [];
    for (var j = 0; j < allThumbs.length; j++) {
      allThumbs[j].style.display = '';
      allThumbs[j].classList.remove('apparel-product__thumbnail--hidden');
      currentVisibleThumbs.push(allThumbs[j]);
    }

    currentSlideIndex = 0;
    requestAnimationFrame(function() {
      scrollToVisibleIndex(0, false);
      highlightVisibleThumb(0);
      buildDots();
      updateArrowState();
    });
  }

  /* ═══════════════════════════════════════════
     GALLERY NAVIGATION
     ═══════════════════════════════════════════ */

  function scrollToVisibleIndex(visIndex, smooth) {
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    if (visIndex < 0 || visIndex >= visible.length) return;
    currentSlideIndex = visIndex;
    var target = visible[visIndex];
    var behavior = smooth !== false ? 'smooth' : 'auto';
    galleryMain.scrollTo({ left: target.offsetLeft, behavior: behavior });
  }

  function getVisibleImages() {
    if (!galleryMain) return [];
    return Array.from(galleryMain.querySelectorAll(
      '.apparel-product__gallery-image:not(.apparel-product__gallery-image--hidden)'
    ));
  }

  function highlightVisibleThumb(visIndex) {
    var allThumbs = thumbnails ? thumbnails.querySelectorAll('.apparel-product__thumbnail') : [];
    for (var i = 0; i < allThumbs.length; i++) {
      allThumbs[i].classList.remove('apparel-product__thumbnail--active');
    }
    var visibleThumbs = currentVisibleThumbs.length ? currentVisibleThumbs :
      Array.from(allThumbs).filter(function(t) {
        return !t.classList.contains('apparel-product__thumbnail--hidden');
      });
    if (visIndex >= 0 && visIndex < visibleThumbs.length) {
      visibleThumbs[visIndex].classList.add('apparel-product__thumbnail--active');
      visibleThumbs[visIndex].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  /* Mobile dot indicators */
  function buildDots() {
    if (!dotsContainer) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    var isMobile = window.innerWidth < 750;
    if (!isMobile || visible.length <= 1) {
      dotsContainer.innerHTML = '';
      dotsContainer.style.display = 'none';
      return;
    }
    dotsContainer.style.display = 'flex';
    var html = '';
    for (var i = 0; i < visible.length; i++) {
      html += '<span class="apparel-product__gallery-dot' +
        (i === currentSlideIndex ? ' apparel-product__gallery-dot--active' : '') +
        '" data-dot-index="' + i + '"></span>';
    }
    dotsContainer.innerHTML = html;
  }

  function updateDotActive(visIndex) {
    if (!dotsContainer) return;
    var dots = dotsContainer.querySelectorAll('.apparel-product__gallery-dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('apparel-product__gallery-dot--active', i === visIndex);
    }
  }

  function getSlideStep() {
    if (!galleryMain) return 0;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    if (!visible.length) return 0;
    var imageWidth = visible[0].offsetWidth;
    var gap = 8;
    if (window.innerWidth < 750) return imageWidth;
    return (imageWidth + gap) * 2;
  }

  function scrollGalleryBy(delta) {
    if (!galleryMain) return;
    galleryMain.scrollBy({ left: delta, behavior: 'smooth' });
    setTimeout(function() {
      syncScrollToSlideIndex();
      updateArrowState();
    }, 350);
  }

  function updateArrowState() {
    if (!galleryMain || !prevArrow || !nextArrow) return;
    var maxScroll = galleryMain.scrollWidth - galleryMain.clientWidth;
    prevArrow.disabled = galleryMain.scrollLeft <= 2;
    nextArrow.disabled = galleryMain.scrollLeft >= maxScroll - 2;
  }

  function syncScrollToSlideIndex() {
    if (!galleryMain) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    var scrollLeft = galleryMain.scrollLeft;
    var closestIdx = 0;
    var closestDist = Infinity;
    for (var i = 0; i < visible.length; i++) {
      var dist = Math.abs(visible[i].offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closestIdx = i;
      }
    }
    currentSlideIndex = closestIdx;
    highlightVisibleThumb(closestIdx);
    updateDotActive(closestIdx);
  }

  function showGalleryImageByGlobalIndex(globalIndex) {
    if (!galleryMain) return;
    var visible = currentVisibleImages.length ? currentVisibleImages : getVisibleImages();
    for (var i = 0; i < visible.length; i++) {
      if (parseInt(visible[i].getAttribute('data-index'), 10) === globalIndex) {
        scrollToVisibleIndex(i, true);
        highlightVisibleThumb(i);
        updateDotActive(i);
        return;
      }
    }
  }

  /* ═══════════════════════════════════════════
     VARIANT UPDATE
     ═══════════════════════════════════════════ */
  function updateVariant() {
    var selectedOptions = [];
    product.options.forEach(function(optName, optIndex) {
      var activeSwatch = document.querySelector(
        '.apparel-product__color-swatch--active[data-option-index="' + optIndex + '"]'
      );
      if (activeSwatch) {
        selectedOptions[optIndex] = activeSwatch.getAttribute('data-value');
        return;
      }
      var activeSize = document.querySelector(
        '.apparel-product__size-btn--active[data-option-index="' + optIndex + '"]'
      );
      if (activeSize) {
        selectedOptions[optIndex] = activeSize.getAttribute('data-value');
        return;
      }
      var selectOpts = variantSelect ? variantSelect.options : [];
      for (var s = 0; s < selectOpts.length; s++) {
        if (selectOpts[s].selected) {
          selectedOptions[optIndex] = selectOpts[s].getAttribute('data-option' + (optIndex + 1));
          break;
        }
      }
    });

    var matchedVariant = variants.find(function(v) {
      return product.options.every(function(opt, i) {
        return v['option' + (i + 1)] === selectedOptions[i];
      });
    });

    if (!matchedVariant) return;

    if (variantSelect) {
      for (var o = 0; o < variantSelect.options.length; o++) {
        variantSelect.options[o].selected = (variantSelect.options[o].value === String(matchedVariant.id));
      }
    }

    var url = new URL(window.location);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState({}, '', url);

    if (priceBlock) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        var discount = Math.round((1 - matchedVariant.price / matchedVariant.compare_at_price) * 100);
        priceBlock.innerHTML =
          '<span class="apparel-product__price--sale">' + formatMoney(matchedVariant.price) + '</span> ' +
          '<span class="apparel-product__price--compare"><s>' + formatMoney(matchedVariant.compare_at_price) + '</s></span> ' +
          '<span class="apparel-product__sale-badge">SALE ' + discount + '% OFF</span>';
      } else {
        priceBlock.innerHTML =
          '<span class="apparel-product__price--regular">' + formatMoney(matchedVariant.price) + '</span>';
      }
    }

    selectedOptions.forEach(function(val, idx) {
      var optionName = (product.options[idx] || '').toLowerCase().replace(/\s+/g, '-');
      var valueDisplay = document.getElementById('apparel-option-' + optionName);
      if (valueDisplay) valueDisplay.textContent = val;
    });

    if (atcBtn && atcText) {
      if (matchedVariant.available) {
        atcBtn.disabled = false;
        atcText.textContent = 'Add to Cart - ' + formatMoney(matchedVariant.price);
      } else {
        atcBtn.disabled = true;
        atcText.textContent = 'Sold Out';
      }
    }

    if (stickyAtc) {
      if (matchedVariant.available) {
        stickyAtc.disabled = false;
        stickyAtc.textContent = 'Add to Cart - ' + formatMoney(matchedVariant.price);
      } else {
        stickyAtc.disabled = true;
        stickyAtc.textContent = 'Sold Out';
      }
    }

    /* ★ FILTER GALLERY BY COLOR ★ */
    if (colorOptionIndex >= 0 && selectedOptions[colorOptionIndex]) {
      filterGalleryByColor(selectedOptions[colorOptionIndex]);
    }
  }

  /* ═══════════════════════════════════════════
     CART FUNCTIONS
     ═══════════════════════════════════════════ */
  /* ---- LOCKED RULE: size must be explicitly chosen before adding to cart ---- */
  function apparelHideSizeError() {
    document.querySelectorAll('[data-size-error]').forEach(function(e) { e.hidden = true; });
    document.querySelectorAll('.apparel-product__option-values--error').forEach(function(w) {
      w.classList.remove('apparel-product__option-values--error');
    });
  }

  function apparelRequireSize() {
    var sizeBtns = document.querySelectorAll('.apparel-product__size-btn');
    if (!sizeBtns.length) return true;               // product has no size-type option
    var groups = {}, missingIdx = null;
    sizeBtns.forEach(function(b) { groups[b.getAttribute('data-option-index')] = true; });
    Object.keys(groups).forEach(function(idx) {
      if (missingIdx === null &&
          !document.querySelector('.apparel-product__size-btn--active[data-option-index="' + idx + '"]')) {
        missingIdx = idx;
      }
    });
    if (missingIdx === null) return true;
    var anyBtn = document.querySelector('.apparel-product__size-btn[data-option-index="' + missingIdx + '"]');
    var block = anyBtn ? anyBtn.closest('.apparel-product__option') : null;
    var err = block ? block.querySelector('[data-size-error]') : document.querySelector('[data-size-error]');
    var wrap = block ? block.querySelector('.apparel-product__option-values') : null;
    if (err) err.hidden = false;
    if (wrap) wrap.classList.add('apparel-product__option-values--error');
    var target = wrap || err;
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  function addToCart(variantId, quantity) {
    if (!variantId) return;
    var body = JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] });
    if (atcBtn) atcBtn.disabled = true;
    if (atcText) atcText.textContent = 'Adding...';
    if (stickyAtc) { stickyAtc.disabled = true; stickyAtc.textContent = 'Adding...'; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function(r) { return r.json(); })
      .then(function() {
        openCartDrawer();
        refreshCartDrawer();
        updateCartCount();
        var currentVariant = variantSelect ? variantSelect.value : null;
        var v = currentVariant ? variants.find(function(vr) { return String(vr.id) === currentVariant; }) : null;
        if (atcBtn) atcBtn.disabled = false;
        if (atcText) atcText.textContent = v ? 'Add to Cart - ' + formatMoney(v.price) : 'Add to Cart';
        if (stickyAtc) { stickyAtc.disabled = false; stickyAtc.textContent = v ? 'Add to Cart - ' + formatMoney(v.price) : 'Add to Cart'; }
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        if (atcBtn) atcBtn.disabled = false;
        if (atcText) atcText.textContent = 'Add to Cart';
        if (stickyAtc) { stickyAtc.disabled = false; stickyAtc.textContent = 'Add to Cart'; }
      });
  }

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('apparel-cart-drawer--open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = '-' + window.scrollY + 'px';
      cartDrawer.setAttribute('data-scroll-pos', window.scrollY);
    }
    if (cartOverlay) { cartOverlay.style.display = 'block'; cartOverlay.classList.add('apparel-cart-overlay--open'); }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      var scrollPos = parseInt(cartDrawer.getAttribute('data-scroll-pos') || '0', 10);
      cartDrawer.classList.remove('apparel-cart-drawer--open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollPos);
    }
    if (cartOverlay) { cartOverlay.classList.remove('apparel-cart-overlay--open'); setTimeout(function() { cartOverlay.style.display = 'none'; }, 300); }
  }

  /* Site-wide handle so legacy per-PDP drawers can route into this one */
  window.CozyCartDrawer = { open: openCartDrawer, refresh: refreshCartDrawer };

  function refreshCartDrawer() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); updateCartCount(cart.item_count); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  /* Color name to CSS hex mapping */
  function cartColorToCSS(name) {
    var n = name.toLowerCase().replace(/[\s-]/g, '');
    var map = {
      'gold': '#D4AF37', 'rosegold': '#B76E79', 'silver': '#C0C0C0',
      'creamwhite': '#F1EAD8', 'darkgreen': '#2E4A3E', 'softpink': '#F2C7CF',
      'black': '#000000', 'white': '#FFFFFF', 'blue': '#4A90D9',
      'red': '#C0392B', 'green': '#27AE60', 'pink': '#E91E8C',
      'purple': '#8E44AD', 'yellow': '#F1C40F', 'orange': '#E67E22',
      'brown': '#8B4513', 'grey': '#808080', 'gray': '#808080',
      'navy': '#001F3F', 'teal': '#008080', 'coral': '#FF7F50',
      'ivory': '#FFFFF0', 'beige': '#F5F5DC', 'champagne': '#F7E7CE',
      'platinum': '#E5E4E2', 'bronze': '#CD7F32', 'copper': '#B87333',
      'skyblue': '#87CEEB', 'darkpink': '#E75480', 'cream': '#FFFDD0',
      'burgundy': '#800020', 'maroon': '#800000', 'olive': '#808000',
      'khaki': '#C3B091', 'tan': '#D2B48C', 'lavender': '#E6E6FA',
      'aurora': '#78B159', 'midnight': '#191970', 'charcoal': '#36454F',
      'blush': '#DE5D83', 'mint': '#98FF98', 'rose': '#FF007F',
      'wine': '#722F37', 'sage': '#BCB88A', 'taupe': '#483C32',
      'leopard': 'linear-gradient(135deg, #b07a3f 0%, #c89559 50%, #d8a76a 100%)',
      'tortoise': 'linear-gradient(135deg, #8b4513 0%, #c89559 60%, #d8a76a 100%)',
      'tortoiseshell': 'linear-gradient(135deg, #8b4513 0%, #c89559 60%, #d8a76a 100%)',
      'cheetah': 'linear-gradient(135deg, #b88455 0%, #d5a26a 100%)',
      'animal': 'linear-gradient(135deg, #b07a3f 0%, #c89559 100%)',
      'strawberrymilk': '#F4B8C4', 'taroswirl': '#C9B3E8', 'blueberryboba': '#8FCDE8',
      'matchalatte': '#9FD18A', 'mangocream': '#F5D96B', 'cloudbluecord': '#A9C4E0',
      'sagegreencord': '#A8BE9E'
    };
    /* exact variant name wins before any substring match, so "Mango Cream" cannot
       resolve to 'cream' and "Sage Green Cord" cannot resolve to 'green' */
    if (map[n]) return map[n];
    var found = null;
    Object.keys(map).forEach(function(key) { if (n.indexOf(key) !== -1 && !found) found = map[key]; });
    return found || '#888888';
  }

  /* Line-item personalization properties from the last render, keyed by line key */
  var cozyLinePropsByKey = {};

  /* Product data cache for color swatches */
  var productDataCache = {};

  function fetchProductData(handle) {
    if (productDataCache[handle]) return Promise.resolve(productDataCache[handle]);
    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var product = data.product;
        /* The public .json endpoint has NO per-variant `available` field, which made
           every size render as in-stock (sold-out swap then emptied the cart line).
           Merge real availability from the .js endpoint before caching. */
        return fetch('/products/' + handle + '.js')
          .then(function(r2) { return r2.ok ? r2.json() : null; })
          .then(function(jsP) {
            if (jsP && jsP.variants) {
              var availById = {};
              jsP.variants.forEach(function(v) { availById[String(v.id)] = v.available; });
              product.variants.forEach(function(v) {
                if (String(v.id) in availById) v.available = availById[String(v.id)];
              });
            }
            productDataCache[handle] = product;
            return product;
          })
          .catch(function() { productDataCache[handle] = product; return product; });
      });
  }

  function getColorOptionFromProduct(product) {
    if (!product.options) return null;
    var colorNames = ['color', 'colour', 'metal', 'finish', 'co'];
    for (var i = 0; i < product.options.length; i++) {
      var opt = product.options[i];
      if (colorNames.indexOf(opt.name.toLowerCase()) !== -1) return opt;
    }
    return null;
  }

  /* Find image URL for a given variant ID or color name from product data */
  function findImageForVariant(product, variantId, colorName) {
    if (!product || !product.images || !product.images.length) return null;
    /* Strategy 1: match by variant_ids on images */
    for (var i = 0; i < product.images.length; i++) {
      var img = product.images[i];
      if (img.variant_ids && img.variant_ids.length && img.variant_ids.indexOf(variantId) !== -1) {
        return img.src;
      }
    }
    /* Strategy 2: match by color name in filename */
    if (colorName) {
      var colorLower = colorName.toLowerCase();
      for (var j = 0; j < product.images.length; j++) {
        var imgSrc = product.images[j].src || '';
        var filename = imgSrc.substring(imgSrc.lastIndexOf('/') + 1).split('?')[0].toLowerCase();
        if (filename.indexOf(colorLower) !== -1) {
          return product.images[j].src;
        }
      }
    }
    /* Strategy 3: match by alt text */
    if (colorName) {
      var cLower = colorName.toLowerCase();
      for (var k = 0; k < product.images.length; k++) {
        var alt = (product.images[k].alt || '').toLowerCase();
        if (alt && alt.indexOf(cLower) !== -1) {
          return product.images[k].src;
        }
      }
    }
    return null;
  }

  function renderCartDrawer(cart) {
    if (!cartLineItems) return;
    if (!cart.items || cart.items.length === 0) {
      cartLineItems.innerHTML = '';
      if (cartEmpty) cartEmpty.style.display = 'block';
      if (cartFooter) cartFooter.style.display = 'none';
      if (cartUpsells) cartUpsells.style.display = 'none';
      return;
    }
    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'block';

    /* Cart-driven trust wording: Personalized Name Necklace carries a Lifetime Warranty.
       When it's in the cart, show that everywhere; otherwise restore the page default. */
    try {
      var cozyHasNecklace = cart.items.some(function(it) { return it.product_id === 8042774724698; });
      var cozyTrustSpans = document.querySelectorAll('ROOT TRUSTCLS > span'.replace('ROOT','#apparel-cart-drawer').replace('TRUSTCLS','.apparel-cart-drawer__trust-row'));
      for (var cti = 0; cti < cozyTrustSpans.length; cti++) {
        var cozySp = cozyTrustSpans[cti];
        if (/Money Back|Lifetime Warranty/.test(cozySp.textContent)) {
          if (!cozySp.dataset.defaultTrust) cozySp.dataset.defaultTrust = (cozySp.textContent.indexOf('Lifetime') !== -1) ? 'Lifetime Warranty' : '30-Day Money Back';
          var cozyIcon = cozySp.querySelector('span');
          var cozyTxt = cozyHasNecklace ? 'Lifetime Warranty' : cozySp.dataset.defaultTrust;
          if (cozyIcon) cozySp.innerHTML = cozyIcon.outerHTML + ' ' + cozyTxt;
          break;
        }
      }
    } catch (cozyErr) {}

    /* Render items first without swatches, then fetch product data for colors */
    var html = '';
    var sizeNames = ['size', 'length', 'width'];
    /* Remember every line's personalization properties, keyed by line key, so a
       color/size swap in the drawer can carry them onto the replacement line. */
    cozyLinePropsByKey = {};
    cart.items.forEach(function(item, idx) {
      cozyLinePropsByKey[item.key] = item.properties || {};
      /* Get current color and size from options_with_values */
      var currentColor = '';
      var currentSize = '';
      var currentLetter = '';
      if (item.options_with_values) {
        for (var o = 0; o < item.options_with_values.length; o++) {
          var optName = item.options_with_values[o].name.toLowerCase();
          if (optName === 'color' || optName === 'colour' || optName === 'metal' || optName === 'finish' || optName === 'co') {
            currentColor = item.options_with_values[o].value;
          }
          if (sizeNames.indexOf(optName) !== -1) {
            currentSize = item.options_with_values[o].value;
          }
          if (optName === 'letter' || optName === 'letters' || optName === 'initial') {
            currentLetter = item.options_with_values[o].value;
          }
        }
      }

      html += '<div class="apparel-cart-item" data-key="' + item.key + '" data-product-handle="' + item.handle + '" data-variant-id="' + item.variant_id + '" data-item-index="' + idx + '">';
      html += '<a href="/products/' + (item.handle || '') + '" class="apparel-cart-item__image-link" aria-label="View ' + item.title + '"><div class="apparel-cart-item__image"><img src="' + item.image + '" alt="' + item.title + '" width="80" height="100" loading="lazy"></div></a>';
      html += '<div class="apparel-cart-item__details">';
      html += '<a href="/products/' + (item.handle || '') + '" class="apparel-cart-item__title-link" style="color:inherit;text-decoration:none;"><p class="apparel-cart-item__title">' + item.product_title + '</p></a>';
      /* Color label + swatches placeholder */
      if (currentColor) {
        html += '<div class="apparel-cart-item__color-row">';
        html += '<span class="apparel-cart-item__color-label">Color: <strong class="apparel-cart-item__color-name">' + currentColor + '</strong></span>';
        html += '<div class="apparel-cart-item__swatches" data-item-key="' + item.key + '"></div>';
        html += '</div>';
      } else if (!currentSize) {
        /* Only show variant_title fallback when neither color NOR size will render below */
        html += '<p class="apparel-cart-item__variant">' + (item.variant_title || '') + '</p>';
      }
      /* Letter option (Heart Initial etc.) — the selected letter must stay visible in the cart */
      if (currentLetter) {
        html += '<div class="apparel-cart-item__size-row apparel-cart-item__letter-row">';
        html += '<span class="apparel-cart-item__size-label">Letter: <strong class="apparel-cart-item__size-name">' + currentLetter + '</strong></span>';
        html += '</div>';
      }
      /* Size label + placeholder for interactive size buttons */
      if (currentSize) {
        html += '<div class="apparel-cart-item__size-row">';
        html += '<span class="apparel-cart-item__size-label">Size: <strong class="apparel-cart-item__size-name">' + currentSize + '</strong></span>';
        html += '<div class="apparel-cart-item__sizes" data-item-key="' + item.key + '"></div>';
        html += '</div>';
      }
      /* Show FREE + crossed-out original price when this line item has been
         fully discounted to $0 (e.g., BOGO 2nd pair). Otherwise show normal price. */
      if (item.final_line_price === 0 && item.original_line_price > 0) {
        html += '<p class="apparel-cart-item__price apparel-cart-item__price--free">' +
                '<s class="apparel-cart-item__price-strike">' + formatMoney(item.original_line_price) + '</s> ' +
                '<span class="apparel-cart-item__price-free">FREE</span>' +
                '</p>';
      } else {
        html += '<p class="apparel-cart-item__price">' + formatMoney(item.final_line_price) + '</p>';
      }
      /* 🔒 BOGO 2026-09-06: Shopify automatic discount "Buy 1, Get 1 20% Off" (necklace). When a line carries
         a line-level discount, name it under the price so the shopper sees WHICH necklace got the 20%. */
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
        var cozyDiscAmt = 0, cozyDiscTitle = '';
        item.line_level_discount_allocations.forEach(function(da){ cozyDiscAmt += (da.amount || 0); if (!cozyDiscTitle && da.discount_application) cozyDiscTitle = da.discount_application.title || ''; });
        if (cozyDiscAmt > 0) html += '<p class="cozy-line-disc" style="margin:2px 0 0;font-size:12px;font-weight:700;color:#2E7D4F;">&#127873; ' + String(cozyDiscTitle).replace(/</g,'&lt;') + ' (&#8722;' + formatMoney(cozyDiscAmt) + ')</p>';
      }
      /* Personalized Name Necklace: a quantity stepper would just clone the SAME
         engraved name, so swap it for "Add another necklace" which closes the
         drawer and sends them back to the page to configure a fresh one. */
      var cozyIsPersonalized = String(item.product_id) === '8042774724698';
      /* Bundle set lines (hidden _set property) are one-per-set by design — no stepper. */
      var cozyIsSetLine = !!(item.properties && item.properties._set);
      html += '<div class="apparel-cart-item__bottom-row">';
      if (!cozyIsPersonalized && !cozyIsSetLine) {
        html += '<div class="apparel-cart-item__qty">';
        html += '<button class="apparel-cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '">&#8722;</button>';
        html += '<span class="apparel-cart-item__qty-value">' + item.quantity + '</span>';
        html += '<button class="apparel-cart-item__qty-btn" data-action="increase" data-key="' + item.key + '">+</button>';
        html += '</div>';
      } else {
        html += '<span class="apparel-cart-item__qty-static">Qty ' + item.quantity + '</span>';
      }
      html += '<button class="apparel-cart-item__remove" data-action="remove" data-key="' + item.key + '">Remove</button>';
      html += '</div>';
      if (cozyIsPersonalized) {
        html += '<button type="button" class="apparel-cart-item__add-another" data-action="add-another-necklace" data-key="' + item.key + '" data-url="/products/personalized-name-necklace">&#43; Add a 2nd necklace &middot; 25% off</button>';
      }
      html += '</div></div>';
    });
    cartLineItems.innerHTML = html;
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price); cozyRenderSavings(cart); cozyEnhanceComparePrices(cart);

    /* Now fetch product data and populate color swatches */
    cart.items.forEach(function(item) {
      if (!item.handle) return;
      var swatchContainer = cartLineItems.querySelector('.apparel-cart-item__swatches[data-item-key="' + item.key + '"]');
      /* NOTE: do NOT early-return when swatchContainer is missing — we still need to populate size buttons for color-less products */

      fetchProductData(item.handle).then(function(product) {
        var colorOpt = getColorOptionFromProduct(product);
        var hasColor = colorOpt && colorOpt.values && colorOpt.values.length >= 2;
        if (!hasColor && swatchContainer) {
          swatchContainer.style.display = 'none';
        }

        /* Find current color value */
        var currentColor = '';
        if (item.options_with_values) {
          for (var o = 0; o < item.options_with_values.length; o++) {
            var optName = item.options_with_values[o].name.toLowerCase();
            if (optName === 'color' || optName === 'colour' || optName === 'metal' || optName === 'finish') {
              currentColor = item.options_with_values[o].value;
              break;
            }
          }
        }

        if (hasColor && swatchContainer) {
        var colorPosition = colorOpt.position;
        var swatchHtml = colorOpt.values.map(function(colorVal) {
          var isActive = colorVal.toLowerCase() === currentColor.toLowerCase();
          /* Match the new colour while preserving every OTHER option of this
             line's variant (size, number of names, ...) - a colour-only match
             lands on that colour's FIRST variant and silently swaps the line
             to a different size/price. Exact combo first; colour-only match
             only as a last-resort fallback. */
          var lineOpts = (item.options_with_values || []).map(function(ov) { return ov.value; });
          var matchVariant = null;
          var colorOnlyFallback = null;
          for (var v = 0; v < product.variants.length; v++) {
            var vr = product.variants[v];
            var vrColor = vr['option' + colorPosition];
            if (!vrColor || vrColor.toLowerCase() !== colorVal.toLowerCase()) continue;
            if (!colorOnlyFallback) colorOnlyFallback = vr;
            var othersMatch = true;
            for (var op = 1; op <= 3; op++) {
              if (op === colorPosition) continue;
              var lineVal = lineOpts[op - 1];
              if (lineVal == null) continue;
              var vrVal = vr['option' + op];
              if (String(vrVal == null ? '' : vrVal).toLowerCase() !== String(lineVal).toLowerCase()) { othersMatch = false; break; }
            }
            if (othersMatch) { matchVariant = vr; break; }
          }
          if (!matchVariant) matchVariant = colorOnlyFallback;
          /* 🔒 Sold-out colours are NOT offered in the drawer (TA 2026-09-01).
             A swap removes the line first and re-adds it; if the target variant
             is unavailable the re-add 422s and the item VANISHES from the cart.
             Availability-driven, never hardcoded — a restock restores it. */
          if (!matchVariant || matchVariant.available === false) return '';
          var vid = matchVariant ? matchVariant.id : '';
          return '<button class="apparel-cart-item__swatch' + (isActive ? ' apparel-cart-item__swatch--active' : '') + '" ' +
            'style="background:' + cartColorToCSS(colorVal) + '" ' +
            'title="' + colorVal + '" ' +
            'data-color="' + colorVal + '" ' +
            'data-variant-id="' + vid + '" ' +
            'data-item-key="' + item.key + '" ' +
            'data-quantity="' + item.quantity + '"' +
            '></button>';
        }).join('');
        swatchContainer.innerHTML = swatchHtml;
        } /* end if (hasColor) */

        /* Populate size buttons for this cart item (runs whether or not colors exist) */
        var sizeContainer = cartLineItems.querySelector('.apparel-cart-item__sizes[data-item-key="' + item.key + '"]');
        if (sizeContainer) {
          var sizeOpt = null;
          var sizeNamesList = ['size', 'length', 'width'];
          if (product.options) {
            for (var soIdx = 0; soIdx < product.options.length; soIdx++) {
              var soName = typeof product.options[soIdx] === 'string' ? product.options[soIdx] : (product.options[soIdx].name || '');
              if (sizeNamesList.indexOf(soName.toLowerCase()) !== -1) { sizeOpt = product.options[soIdx]; break; }
            }
          }
          if (sizeOpt && sizeOpt.values && sizeOpt.values.length >= 2) {
            var sizePos = sizeOpt.position;
            var currentSizeVal = '';
            if (item.options_with_values) {
              for (var ow = 0; ow < item.options_with_values.length; ow++) {
                if (sizeNamesList.indexOf(item.options_with_values[ow].name.toLowerCase()) !== -1) {
                  currentSizeVal = item.options_with_values[ow].value;
                  break;
                }
              }
            }
            /* Re-resolve colorOpt + currentColorVal in this scope so size buttons render
               correctly even if the swatch block didn't run for this item. */
            var localColorOpt = (typeof colorOpt !== 'undefined' && colorOpt) ? colorOpt : getColorOptionFromProduct(product);
            var currentColorVal = '';
            if (item.options_with_values) {
              var colorNamesLocal = ['color', 'colour', 'metal', 'finish'];
              for (var ow2 = 0; ow2 < item.options_with_values.length; ow2++) {
                if (colorNamesLocal.indexOf(item.options_with_values[ow2].name.toLowerCase()) !== -1) {
                  currentColorVal = item.options_with_values[ow2].value;
                  break;
                }
              }
            }
            var sizeBtnHtml = sizeOpt.values.map(function(sv) {
              var svStr = typeof sv === 'object' ? (sv.value || sv.name || String(sv)) : String(sv);
              var isActiveSize = svStr.toLowerCase() === currentSizeVal.toLowerCase();
              /* Find matching variant: same color (if applicable), this size */
              var matchV = null;
              for (var vv = 0; vv < product.variants.length; vv++) {
                var variant = product.variants[vv];
                var sizeMatch = variant['option' + sizePos] && String(variant['option' + sizePos]).toLowerCase() === svStr.toLowerCase();
                var colorMatch = true;
                if (localColorOpt && currentColorVal) {
                  var cPos = localColorOpt.position;
                  colorMatch = variant['option' + cPos] && String(variant['option' + cPos]).toLowerCase() === currentColorVal.toLowerCase();
                }
                if (sizeMatch && colorMatch) { matchV = variant; break; }
              }
              /* Fallback: if no color match, try matching by size only (saves the cart from showing all sold-out) */
              if (!matchV) {
                for (var vv2 = 0; vv2 < product.variants.length; vv2++) {
                  var variant2 = product.variants[vv2];
                  if (variant2['option' + sizePos] && String(variant2['option' + sizePos]).toLowerCase() === svStr.toLowerCase()) {
                    matchV = variant2;
                    break;
                  }
                }
              }
              var svid = matchV ? matchV.id : '';
              /* Trust matchV.available — if Shopify says it's available, render as such.
                 Default to TRUE when we have a variant match but `available` is undefined
                 (some products with inventory_management=null report differently). */
              var avail = matchV ? (matchV.available !== false) : false;
              return '<button class="apparel-cart-item__size-btn' + (isActiveSize ? ' apparel-cart-item__size-btn--active' : '') + (avail ? '' : ' apparel-cart-item__size-btn--soldout') + '" ' +
                'data-size="' + svStr + '" ' +
                'data-variant-id="' + svid + '" ' +
                'data-item-key="' + item.key + '" ' +
                'data-quantity="' + item.quantity + '"' +
                (avail ? '' : ' disabled') +
                '>' + svStr + '</button>';
            }).join('');
            sizeContainer.innerHTML = sizeBtnHtml;
          } else {
            sizeContainer.style.display = 'none';
          }
        }

        /* Fix image to match current color (cart API may return default image) */
        if (currentColor && swatchContainer) {
          var variantId = parseInt(item.variant_id, 10);
          var correctSrc = findImageForVariant(product, variantId, currentColor);
          if (correctSrc) {
            var cartItemEl = swatchContainer.closest('.apparel-cart-item');
            if (cartItemEl) {
              var imgEl = cartItemEl.querySelector('.apparel-cart-item__image img');
              if (imgEl) imgEl.src = correctSrc.replace(/(\.\w+)(\?.*)?$/, '_200x$1');
            }
          }
        }
      });
    });

    /* Load upsells based on first cart item's product */
    var firstProductId = cart.items[0].product_id;
    loadCartUpsells(firstProductId, cart.items);
  }

  var lastUpsellCartKey = null;
  /* PIN: SoftFlow Drift Set is pinned as the first cart upsell when cart contains these products */
  var pinDriftSetForCartProductIds = { 7888000548954: true, 7878486589530: true }; /* CloudFlow Pants, SoftFlow Lounge Set */
  var driftSetPinnedHandle = 'softflow-drift-set';
  var driftSetPinnedProductId = 7888881942618;

  /* PIN: SoftFlow Lounge Set is pinned as slot #1 ONLY when SoftFlow Drift Set is in the cart.
     Slot #2 then rotates from the shuffled pool below (curated list or pajamas fallback).
     Skipped if Lounge Set itself is already in the cart. */
  var pinLoungeSetForCartProductIds = { 7888881942618: true }; /* SoftFlow Drift Set */
  var loungeSetPinnedHandle = 'softflow-lounge-set';
  var loungeSetPinnedProductId = 7878486589530;

  /* PIN: Ribbon Dreams Pajama Set is pinned as slot #1 when cart contains these products.
     Skipped if Ribbon Dreams itself is already in the cart. */
  var pinRibbonDreamsForCartProductIds = { 7927216767066: true }; /* Pickle Lover Pajama Set */
  var ribbonDreamsPinnedHandle = 'ribbon-dreams-pajama-set';
  var ribbonDreamsPinnedProductId = 7905343668314;

  /* CURATED upsell lists per product in cart — when set, these REPLACE the pajamas-collection fetch.
     Order matters: shuffled then sliced. Mirrors the apparel-recommendations curation. */
  var curatedCartUpsellsByProductId = {
    /* CloudFlow Pants: SoftFlow Drift Set is pinned via the existing rule above; these are the rest */
    7888000548954: ['luna-bloom-dress', 'sienna-sunset-dress', 'cloudease-lounge-set'],
    /* CloudEase Slip-Ons: cart drawer locked to CloudStep Shoes + Love Slippers ONLY */
    7917675741274: ['cloudstep-shoes', 'love-slippers'],
    /* Sorella Bow Sandals: cart drawer locked to CloudStep Shoes + Bella Bow Heels ONLY */
    7916014075994: ['cloudstep-shoes', 'bella-bow-heels'],
    /* Sienna Wedge Slip-Ons: cart drawer locked to Sorella Bow Sandals ONLY */
    7936078577754: ['sorella-bow-sandals'],
    /* Cloudstep Comfort Sandal: cart drawer locked to Sienna Wedge Slip-Ons ONLY */
    7999136825434: ['sienna-wedge-slip-ons'],
    /* Bella Breeze Maxi Dress: cart drawer shows ONLY Sienna Wedge Slip-Ons */
    7977325396058: ['sienna-wedge-slip-ons'],
    /* Pink Cowgirl PJ Set: cart drawer shows ONLY Pickle Lover + Ribbon Dreams pajama sets */
    8000682098778: ['pickle-lover-pajama-set', 'ribbon-dreams-pajama-set'],
    /* Personalized Name Necklace: cart drawer locked to Heart Initial Necklace ONLY */
    8042774724698: ['heart-initial-necklace'],
    /* Sparkle Initial Necklace (2026-10-24, TA): cart drawer locked to Heart Initial Necklace ONLY */
    15445306605658: ['heart-initial-necklace'],
    /* Family Tree + Flower Name Necklace (2026-10-27, TA): jewelry carts show the Heart Initial on every page, not pajamas */
    8169499263066: ['heart-initial-necklace'],
    8136792375386: ['heart-initial-necklace'],
    /* ChillClip Wearable Fan: cart drawer locked to Arctic Mist Cooling Fan ONLY */
    8045226524762: ['arctic-mist-cooling-fan'],
    /* Miso Cozy Pajama Set: cart drawer shows ONLY Pink Cowgirl PJ Set */
    8057151455322: ['pink-cowgirl-pj-set'],
    /* Cozy Cloud Slippers: cart drawer locked to CloudComfort Slippers Women ONLY (TA 8/12) */
    8051604422746: ['cloudcomfort-women'],
    /* SculptFlow Bodysuit: cart drawer locked to SoftFlow Lounge Set ONLY (TA 8/13) */
    8058471579738: ['softflow-lounge-set'],
    /* Cozy Halloween Nights Set: cart drawer locked to Pickle Lover Pajama Set ONLY (TA 9/22) */
    8152877531226: ['pickle-lover-pajama-set'],
    /* Solia Flow Pants: cart drawer locked to SoftFlow Lounge Set ONLY (TA 9/29, this page only) */
    8172457197658: ['softflow-lounge-set'],
    /* Bear Hug Fleece Nightgown: cart drawer locked to Sleepy Sloth Pajama Set ONLY (TA 10/20, this page only) */
    15429138448474: ['sleepy-sloth-pajama-set']
  };
  /* 50% OFF chip on the recommended card ONLY when Solia Flow Pants is in the cart (TA 9/29, this page only) */
  var upsellPctChipForCartProductIds = { 8172457197658: true };

  /* Fixed chain-length display + auto line-item property for specific upsell products */
  var upsellFixedLengthByHandle = { 'heart-initial-necklace': '45 cm (18\u2033)' };

  function fetchProductByHandleForCart(handle) {
    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(d) { return d && d.product ? d.product : null; })
      .catch(function() { return null; });
  }

  function fetchPinnedDriftSet(cartProductIds) {
    var shouldPin = false;
    for (var i = 0; i < cartProductIds.length; i++) {
      if (pinDriftSetForCartProductIds[cartProductIds[i]]) { shouldPin = true; break; }
    }
    /* Don't pin if drift set already in cart */
    if (cartProductIds.indexOf(driftSetPinnedProductId) !== -1) shouldPin = false;
    if (!shouldPin) return Promise.resolve(null);
    return fetchProductByHandleForCart(driftSetPinnedHandle);
  }

  function fetchPinnedLoungeSet(cartProductIds) {
    /* Pin Lounge Set ONLY when one of the trigger products is in the cart (e.g., Drift Set) */
    var shouldPin = false;
    for (var i = 0; i < cartProductIds.length; i++) {
      if (pinLoungeSetForCartProductIds[cartProductIds[i]]) { shouldPin = true; break; }
    }
    if (cartProductIds.indexOf(loungeSetPinnedProductId) !== -1) shouldPin = false;
    if (!shouldPin) return Promise.resolve(null);
    return fetchProductByHandleForCart(loungeSetPinnedHandle);
  }

  function fetchPinnedRibbonDreams(cartProductIds) {
    /* Pin Ribbon Dreams ONLY when one of the trigger products is in the cart (e.g., Pickle Lover) */
    var shouldPin = false;
    for (var i = 0; i < cartProductIds.length; i++) {
      if (pinRibbonDreamsForCartProductIds[cartProductIds[i]]) { shouldPin = true; break; }
    }
    if (cartProductIds.indexOf(ribbonDreamsPinnedProductId) !== -1) shouldPin = false;
    if (!shouldPin) return Promise.resolve(null);
    return fetchProductByHandleForCart(ribbonDreamsPinnedHandle);
  }

  function fetchCuratedCartListIfDefined(cartProductIds) {
    /* Use the first matching cart product's curated list */
    var handles = null;
    for (var i = 0; i < cartProductIds.length; i++) {
      if (curatedCartUpsellsByProductId[cartProductIds[i]]) {
        handles = curatedCartUpsellsByProductId[cartProductIds[i]];
        break;
      }
    }
    if (!handles || handles.length === 0) return Promise.resolve(null);
    return Promise.all(handles.map(fetchProductByHandleForCart)).then(function(arr) {
      return arr.filter(function(p) { return p; });
    });
  }

  /* Cart-driven upsell suppression: with any of these products in the cart the
     "Recommended for You" block is hidden entirely (nothing related to show yet).
     Keep this map identical in apparel-product.js AND new-footwear-product.js. */
  var suppressCartUpsellsForProductIds = {
    8083649298522: true /* BobaPop Pencil Case */
  };

  function loadCartUpsells(productId, cartItems, forceReload) {
    if (!cartUpsells || !cartUpsellItems) return;
    /* Build a stable cache key from cart product IDs so we skip re-render when cart hasn't changed */
    var cartProductIds = cartItems.map(function(item) { return item.product_id; });
    for (var su = 0; su < cartProductIds.length; su++) {
      if (suppressCartUpsellsForProductIds[cartProductIds[su]]) {
        cartUpsells.style.display = 'none';
        lastUpsellCartKey = null;
        return;
      }
    }
    var cacheKey = cartProductIds.sort().join(',');
    if (!forceReload && lastUpsellCartKey === cacheKey && cartUpsells.style.display === 'block') return;
    lastUpsellCartKey = cacheKey;
    /* Fetch in parallel: pajamas (fallback), curated list (override), pinned drift set, pinned lounge set, pinned ribbon dreams */
    Promise.all([
      fetch('/collections/pajamas/products.json?limit=20').then(function(r) { return r.json(); }),
      fetchPinnedDriftSet(cartProductIds),
      fetchCuratedCartListIfDefined(cartProductIds),
      fetchPinnedLoungeSet(cartProductIds),
      fetchPinnedRibbonDreams(cartProductIds)
    ])
      .then(function(results) {
        var data = results[0];
        var pinnedDriftSet = results[1];
        var curated = results[2];
        var pinnedLoungeSet = results[3];
        var pinnedRibbonDreams = results[4];

        /* If a curated list is defined for any cart product, use it instead of pajamas */
        var sourceProducts;
        if (curated && curated.length > 0) {
          sourceProducts = curated;
        } else if (data && data.products) {
          sourceProducts = data.products;
        } else {
          sourceProducts = [];
        }

        if (sourceProducts.length === 0 && !pinnedDriftSet && !pinnedLoungeSet && !pinnedRibbonDreams) {
          cartUpsells.style.display = 'none';
          return;
        }
        /* Filter out products already in cart and any pinned-product duplicates */
        var upsellProducts = sourceProducts.filter(function(p) {
          if (cartProductIds.indexOf(p.id) !== -1) return false;
          if (pinnedDriftSet && p.id === pinnedDriftSet.id) return false;
          if (pinnedLoungeSet && p.id === pinnedLoungeSet.id) return false;
          if (pinnedRibbonDreams && p.id === pinnedRibbonDreams.id) return false;
          return true;
        });
        /* Shuffle so non-pinned slots rotate each time the drawer opens */
        for (var si = upsellProducts.length - 1; si > 0; si--) {
          var ri = Math.floor(Math.random() * (si + 1));
          var tmp = upsellProducts[si];
          upsellProducts[si] = upsellProducts[ri];
          upsellProducts[ri] = tmp;
        }
        /* Build final list (cap at 2): Ribbon Dreams #1 (when applicable),
           then Lounge Set / Drift Set / rotating shuffled product fills slot #2 */
        var finalUpsells = [];
        if (pinnedRibbonDreams) {
          /* Pickle Lover Pajama Set: show ONLY Ribbon Dreams — single recommendation, no other upsells */
          finalUpsells.push(pinnedRibbonDreams);
        } else if (cartProductIds.indexOf(loungeSetPinnedProductId) !== -1 && pinnedDriftSet) {
          /* SoftFlow Lounge Set: show ONLY SoftFlow Drift Set — single recommendation, no other upsells */
          finalUpsells.push(pinnedDriftSet);
        } else {
          if (finalUpsells.length < 2 && pinnedLoungeSet) finalUpsells.push(pinnedLoungeSet);
          if (finalUpsells.length < 2 && pinnedDriftSet) finalUpsells.push(pinnedDriftSet);
          while (finalUpsells.length < 2 && upsellProducts.length > 0) {
            finalUpsells.push(upsellProducts.shift());
          }
        }
        upsellProducts = finalUpsells;

        if (upsellProducts.length === 0) {
          cartUpsells.style.display = 'none';
          return;
        }

        var html = '';
        upsellProducts.forEach(function(p, pIdx) {
          var rawImg = p.featured_image || (p.images && p.images.length ? p.images[0].src : '') || '';
          var imgSrc = rawImg ? rawImg.replace(/(\.\w+)(\?.*)?$/, '_200x$1$2') : '';
          /* Collection API returns price as string on variants, recommendations API returns cents on product */
          var firstVariant = p.variants && p.variants.length ? p.variants[0] : null;
          var priceCents = p.price || (firstVariant ? Math.round(parseFloat(firstVariant.price) * 100) : 0);
          var compareCents = p.compare_at_price || (firstVariant && firstVariant.compare_at_price ? Math.round(parseFloat(firstVariant.compare_at_price) * 100) : 0);
          var price = priceCents ? formatMoney(priceCents) : '';
          var comparePrice = compareCents && compareCents > priceCents ? '<span class="apparel-cart-upsell__compare">' + formatMoney(compareCents) + '</span>' : '';
          var variantId = firstVariant ? firstVariant.id : '';

          /* Get color options from collection/recommendations data */
          var colorOpt = null;
          var colorNames = ['color', 'colour', 'metal', 'finish', 'co'];
          if (p.options) {
            for (var oi = 0; oi < p.options.length; oi++) {
              var opt = p.options[oi];
              var optName = typeof opt === 'string' ? opt : (opt.name || '');
              if (colorNames.indexOf(optName.toLowerCase()) !== -1) { colorOpt = opt; break; }
            }
          }
          var colorValues = [];
          if (colorOpt) {
            if (Array.isArray(colorOpt.values)) {
              colorValues = colorOpt.values.map(function(v) { return typeof v === 'object' ? (v.value || v.name || String(v)) : String(v); });
            }
          }
          var colorPosition = colorOpt ? (colorOpt.position || 1) : 1;
          /* 🔒 Upsell: never offer a colour with no purchasable variant (TA 2026-09-01). */
          if (p.variants && colorValues.length) {
            colorValues = colorValues.filter(function(cv) {
              for (var av = 0; av < p.variants.length; av++) {
                var avv = p.variants[av];
                var avc = avv['option' + colorPosition];
                if (avc && String(avc).toLowerCase() === String(cv).toLowerCase() && avv.available !== false) return true;
              }
              return false;
            });
          }

          /* Build color swatches HTML for upsell */
          var swatchHtml = '';
          if (colorValues.length >= 2) {
            swatchHtml = '<div class="apparel-cart-upsell__swatches">';
            swatchHtml += '<span class="apparel-cart-upsell__color-label">Color: <strong class="apparel-cart-upsell__color-name">' + colorValues[0] + '</strong></span>';
            swatchHtml += '<div class="apparel-cart-upsell__swatch-row">';
            colorValues.forEach(function(cv, si) {
              /* Find variant for this color */
              var matchVid = variantId;
              if (p.variants) {
                for (var vi = 0; vi < p.variants.length; vi++) {
                  if (p.variants[vi]['option' + colorPosition] && p.variants[vi]['option' + colorPosition].toLowerCase() === cv.toLowerCase() && p.variants[vi].available !== false) {
                    matchVid = p.variants[vi].id;
                    break;
                  }
                }
              }
              swatchHtml += '<button class="apparel-cart-upsell__swatch' + (si === 0 ? ' apparel-cart-upsell__swatch--active' : '') + '" ' +
                'style="background:' + cartColorToCSS(cv) + '" ' +
                'title="' + cv + '" ' +
                'data-color="' + cv + '" ' +
                'data-variant-id="' + matchVid + '" ' +
                'data-upsell-index="' + pIdx + '" ' +
                'data-handle="' + (p.handle || '') + '"' +
                '></button>';
            });
            swatchHtml += '</div></div>';
          }

          /* Build size buttons HTML for upsell */
          var sizeOpt = null;
          var upsellSizeNames = ['size', 'length', 'width'];
          if (p.options) {
            for (var si2 = 0; si2 < p.options.length; si2++) {
              var sOpt = p.options[si2];
              var sOptName = typeof sOpt === 'string' ? sOpt : (sOpt.name || '');
              if (upsellSizeNames.indexOf(sOptName.toLowerCase()) !== -1) { sizeOpt = sOpt; break; }
            }
          }
          var sizeValues = [];
          if (sizeOpt) {
            if (Array.isArray(sizeOpt.values)) {
              sizeValues = sizeOpt.values.map(function(v) { return typeof v === 'object' ? (v.value || v.name || String(v)) : String(v); });
            }
          }
          var sizePosition = sizeOpt ? (sizeOpt.position || 1) : 1;

          var sizeHtml = '';
          if (sizeValues.length >= 2) {
            sizeHtml = '<div class="apparel-cart-upsell__size-wrap">';
            sizeHtml += '<span class="apparel-cart-upsell__size-label">Size: <strong class="apparel-cart-upsell__size-name">' + sizeValues[0] + '</strong></span>';
            sizeHtml += '<div class="apparel-cart-upsell__sizes">';
            sizeValues.forEach(function(sv, si3) {
              sizeHtml += '<button class="apparel-cart-upsell__size-btn' + (si3 === 0 ? ' apparel-cart-upsell__size-btn--active' : '') + '" ' +
                'data-size="' + sv + '" ' +
                'data-size-position="' + sizePosition + '" ' +
                'data-upsell-index="' + pIdx + '">' + sv + '</button>';
            });
            sizeHtml += '</div></div>';
          }

          /* Letter/initial option (e.g. Heart Initial Necklace, 26 values): compact dropdown, not buttons */
          var letterOpt = null;
          var letterNames = ['letter', 'initial'];
          if (p.options) {
            for (var li0 = 0; li0 < p.options.length; li0++) {
              var lOpt = p.options[li0];
              var lOptName = typeof lOpt === 'string' ? lOpt : (lOpt.name || '');
              if (letterNames.indexOf(lOptName.toLowerCase()) !== -1) { letterOpt = lOpt; break; }
            }
          }
          var letterValues = [];
          if (letterOpt && Array.isArray(letterOpt.values)) {
            letterValues = letterOpt.values.map(function(v) { return typeof v === 'object' ? (v.value || v.name || String(v)) : String(v); });
          }
          var letterHtml = '';
          if (letterValues.length >= 2) {
            letterHtml = '<div class="apparel-cart-upsell__letter-wrap">';
            letterHtml += '<select class="apparel-cart-upsell__letter" aria-label="Choose your letter">';
            letterHtml += '<option value="" selected disabled>Choose your letter</option>';
            letterValues.forEach(function(lv2) {
              letterHtml += '<option value="' + lv2 + '">' + lv2 + '</option>';
            });
            letterHtml += '</select></div>';
          }
          var fixedLen = upsellFixedLengthByHandle[p.handle || ''];
          if (fixedLen) {
            letterHtml += '<div class="apparel-cart-upsell__fixed-len">Chain length: <strong>' + fixedLen + '</strong></div>';
          }

          html += '<div class="apparel-cart-upsell" data-handle="' + (p.handle || '') + '" data-variants=\'' + JSON.stringify(
            (p.variants || []).map(function(v) { return { id: v.id, o1: v.option1, o2: v.option2, o3: v.option3 }; })
          ) + '\'>';
          html += '<div class="apparel-cart-upsell__top">';
          html += '<a class="apparel-cart-upsell__image-link" href="/products/' + (p.handle || '') + '" aria-label="View ' + p.title + '">';
          html += '<img class="apparel-cart-upsell__image" src="' + imgSrc + '" alt="' + p.title + '" width="60" height="75" loading="lazy">';
          html += '</a>';
          html += '<div class="apparel-cart-upsell__info">';
          html += '<a class="apparel-cart-upsell__title-link" href="/products/' + (p.handle || '') + '" style="color:inherit;text-decoration:none;">';
          html += '<p class="apparel-cart-upsell__title">' + p.title + '</p>';
          html += '</a>';
          var pctChip = (compareCents > priceCents && cartProductIds.some(function(cid) { return upsellPctChipForCartProductIds[cid]; })) ? '<span class="cozy-pct-chip">' + Math.round(100 - (priceCents / compareCents) * 100) + '% OFF</span>' : '';
          html += '<div class="apparel-cart-upsell__price-row">' + comparePrice + '<span class="apparel-cart-upsell__price">' + price + '</span>' + pctChip + '</div>';
          html += swatchHtml;
          html += sizeHtml;
          html += letterHtml;
          html += '</div>';
          html += '</div>';
          html += '<button class="apparel-cart-upsell__add-btn" data-variant-id="' + variantId + '">Add to Cart</button>';
          html += '</div>';
        });
        cartUpsellItems.innerHTML = html;
        cartUpsells.style.display = 'block';

        /* Wire up upsell title/image link clicks: close the drawer first so the back button
           returns the customer to the previous page instead of re-opening the drawer */
        cartUpsellItems.querySelectorAll('.apparel-cart-upsell__title-link, .apparel-cart-upsell__image-link').forEach(function(link) {
          link.addEventListener('click', function() {
            if (typeof closeCartDrawer === 'function') closeCartDrawer();
          });
        });

        /* Letter selects: clear error state on choose */
        cartUpsellItems.querySelectorAll('.apparel-cart-upsell__letter').forEach(function(sel) {
          sel.addEventListener('change', function() { sel.classList.remove('apparel-cart-upsell__letter--err'); });
        });

        /* Wire up upsell add buttons */
        cartUpsellItems.querySelectorAll('.apparel-cart-upsell__add-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var vid = btn.getAttribute('data-variant-id');
            var letterCard = btn.closest('.apparel-cart-upsell');
            var letterSel = letterCard ? letterCard.querySelector('.apparel-cart-upsell__letter') : null;
            if (letterSel) {
              if (!letterSel.value) {
                letterSel.classList.add('apparel-cart-upsell__letter--err');
                letterSel.focus();
                return;
              }
              var lVariants = [];
              try { lVariants = JSON.parse(letterCard.getAttribute('data-variants') || '[]'); } catch(e) {}
              for (var lvi = 0; lvi < lVariants.length; lvi++) {
                var lvv = lVariants[lvi];
                if ([lvv.o1, lvv.o2, lvv.o3].indexOf(letterSel.value) !== -1) { vid = String(lvv.id); break; }
              }
            }
            if (!vid) return;
            btn.disabled = true;
            btn.textContent = 'Adding...';
            var addPayload = { id: parseInt(vid, 10), quantity: 1 };
            var lenHandle = letterCard ? letterCard.getAttribute('data-handle') : '';
            if (lenHandle && upsellFixedLengthByHandle[lenHandle]) {
              addPayload.properties = { 'Chain Length': upsellFixedLengthByHandle[lenHandle] };
            }
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(addPayload)
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              btn.textContent = 'Added!';
              refreshCartDrawer();
              updateCartCount();
              setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500);
            })
            .catch(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; });
          });
        });

        /* Helper: find matching variant from stored variants data based on selected color + size */
        function findUpsellVariant(upsellCard) {
          var variants = [];
          try { variants = JSON.parse(upsellCard.getAttribute('data-variants') || '[]'); } catch(e) {}
          var activeSwatch = upsellCard.querySelector('.apparel-cart-upsell__swatch--active');
          var activeSize = upsellCard.querySelector('.apparel-cart-upsell__size-btn--active');
          var selectedColor = activeSwatch ? activeSwatch.getAttribute('data-color') : '';
          var selectedSize = activeSize ? activeSize.getAttribute('data-size') : '';

          /* Try to find exact match for color + size */
          for (var vi = 0; vi < variants.length; vi++) {
            var v = variants[vi];
            var opts = [v.o1, v.o2, v.o3].filter(Boolean).map(function(o) { return o.toLowerCase(); });
            var colorMatch = !selectedColor || opts.indexOf(selectedColor.toLowerCase()) !== -1;
            var sizeMatch = !selectedSize || opts.indexOf(selectedSize.toLowerCase()) !== -1;
            if (colorMatch && sizeMatch) return v.id;
          }
          /* Fallback: just color match */
          if (selectedColor) {
            for (var vi2 = 0; vi2 < variants.length; vi2++) {
              var v2 = variants[vi2];
              var opts2 = [v2.o1, v2.o2, v2.o3].filter(Boolean).map(function(o) { return o.toLowerCase(); });
              if (opts2.indexOf(selectedColor.toLowerCase()) !== -1) return v2.id;
            }
          }
          return variants.length ? variants[0].id : '';
        }

        /* Wire up upsell swatch clicks */
        cartUpsellItems.querySelectorAll('.apparel-cart-upsell__swatch').forEach(function(swatch) {
          swatch.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var newColor = swatch.getAttribute('data-color');
            var handle = swatch.getAttribute('data-handle');
            var upsellCard = swatch.closest('.apparel-cart-upsell');
            if (!upsellCard) return;

            /* Update active state */
            upsellCard.querySelectorAll('.apparel-cart-upsell__swatch').forEach(function(s) {
              s.classList.remove('apparel-cart-upsell__swatch--active');
            });
            swatch.classList.add('apparel-cart-upsell__swatch--active');

            /* Update color name label */
            var colorNameEl = upsellCard.querySelector('.apparel-cart-upsell__color-name');
            if (colorNameEl && newColor) colorNameEl.textContent = newColor;

            /* Find correct variant based on color + size selection */
            var matchedVid = findUpsellVariant(upsellCard);
            var addBtn = upsellCard.querySelector('.apparel-cart-upsell__add-btn');
            if (addBtn && matchedVid) addBtn.setAttribute('data-variant-id', matchedVid);

            /* Update the product image — preload to prevent flash */
            if (handle) {
              fetchProductData(handle).then(function(product) {
                var newImgSrc = findImageForVariant(product, parseInt(matchedVid, 10), newColor);
                if (newImgSrc) {
                  var imgEl = upsellCard.querySelector('.apparel-cart-upsell__image');
                  if (imgEl) {
                    var finalSrc = newImgSrc.replace(/(\.\w+)(\?.*)?$/, '_200x$1');
                    var preload = new Image();
                    preload.onload = function() { imgEl.src = finalSrc; };
                    preload.src = finalSrc;
                  }
                }
              });
            }
          });
        });

        /* Wire up upsell size button clicks */
        cartUpsellItems.querySelectorAll('.apparel-cart-upsell__size-btn').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var upsellCard = btn.closest('.apparel-cart-upsell');
            if (!upsellCard) return;

            /* Update active state */
            upsellCard.querySelectorAll('.apparel-cart-upsell__size-btn').forEach(function(b) {
              b.classList.remove('apparel-cart-upsell__size-btn--active');
            });
            btn.classList.add('apparel-cart-upsell__size-btn--active');

            /* Update size name label */
            var sizeNameEl = upsellCard.querySelector('.apparel-cart-upsell__size-name');
            if (sizeNameEl) sizeNameEl.textContent = btn.getAttribute('data-size');

            /* Find correct variant based on color + size selection */
            var matchedVid = findUpsellVariant(upsellCard);
            var addBtnEl = upsellCard.querySelector('.apparel-cart-upsell__add-btn');
            if (addBtnEl && matchedVid) addBtnEl.setAttribute('data-variant-id', matchedVid);
          });
        });
      })
      .catch(function() {
        if (cartUpsells) cartUpsells.style.display = 'none';
      });
  }

  function handleCartItemClick(e) {
    /* Handle swatch click */
    var swatch = e.target.closest('.apparel-cart-item__swatch');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      handleCartSwatchClick(swatch);
      return;
    }

    /* Handle size button click */
    var sizeBtn = e.target.closest('.apparel-cart-item__size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      handleCartSizeClick(sizeBtn);
      return;
    }

    var target = e.target.closest('[data-action]');
    if (!target) return;
    var action = target.getAttribute('data-action');
    var key = target.getAttribute('data-key');
    if (!key) return;
    if (action === 'add-another-necklace') {
      e.preventDefault();
      var cozyUrl = target.getAttribute('data-url') || '/products/personalized-name-necklace';
      closeCartDrawer();
      if (window.location.pathname === cozyUrl) {
        var cozyTop = document.getElementById('fn-top') || document.querySelector('.fn-counts');
        if (cozyTop) setTimeout(function() { cozyTop.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 320);
        /* 🔒 2026-09-06 (TA): clear the NAME fields only, so a second click + Add can't create an accidental
           duplicate of the first necklace. Color and length stay as chosen. Fires 'input' so the live preview clears. */
        document.querySelectorAll('#fnNameFields .fn-name-input').forEach(function(inp) {
          inp.value = '';
          inp.dispatchEvent(new Event('input', { bubbles: true }));
        });
      } else {
        window.location.href = cozyUrl;
      }
      return;
    }
    if (action === 'remove') updateCartItem(key, 0);
    else if (action === 'decrease') {
      var qtyEl = target.parentElement.querySelector('.apparel-cart-item__qty-value');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      updateCartItem(key, Math.max(0, qty - 1));
    } else if (action === 'increase') {
      var qtyEl2 = target.parentElement.querySelector('.apparel-cart-item__qty-value');
      var qty2 = qtyEl2 ? parseInt(qtyEl2.textContent, 10) : 1;
      updateCartItem(key, qty2 + 1);
    }
  }

  var swatchSwapping = false;
  /* 🔒 STABLE LINE ORDER (TA 2026-08-11): a drawer swap must never visually
     re-order the cart or disturb the other lines. Shopify's add.js prepends
     re-added lines and RE-HASHES EVERY line key on any cart mutation, so after
     a swap we re-render the whole drawer (fresh keys on every line) but in the
     PRE-swap display order — lines matched by identity (variant + properties),
     with the swapped-in line inheriting the swapped-out line's slot. */
  function cozyLineIdentity(item) {
    return String(item.variant_id) + '|' + JSON.stringify(item.properties || {});
  }
  function cozyStableOrder(cart, prevIds, swapSlot) {
    if (!prevIds || !prevIds.length) return cart;
    var used = {}, slots = new Array(prevIds.length), leftovers = [];
    cart.items.forEach(function(it) {
      var id = cozyLineIdentity(it), idx = -1;
      for (var i = 0; i < prevIds.length; i++) {
        if (!used[i] && prevIds[i] === id) { idx = i; break; }
      }
      if (idx > -1) { used[idx] = true; slots[idx] = it; }
      else { leftovers.push(it); }
    });
    if (leftovers.length && swapSlot > -1 && !slots[swapSlot]) {
      slots[swapSlot] = leftovers.shift();
    }
    var ordered = [];
    slots.forEach(function(it) { if (it) ordered.push(it); });
    leftovers.forEach(function(it) { ordered.push(it); });
    if (ordered.length === cart.items.length) cart.items = ordered;
    return cart;
  }

  function handleCartSwatchClick(swatch) {
    /* Prevent double-tap / rapid clicks */
    if (swatchSwapping) return;

    var newVariantId = swatch.getAttribute('data-variant-id');
    var itemKey = swatch.getAttribute('data-item-key');
    var quantity = parseInt(swatch.getAttribute('data-quantity') || '1', 10);
    var newColor = swatch.getAttribute('data-color');
    if (!newVariantId || !itemKey) return;

    /* If clicking the already active swatch, do nothing */
    if (swatch.classList.contains('apparel-cart-item__swatch--active')) return;

    /* Lock to prevent duplicate operations */
    swatchSwapping = true;
    var cozyPrevIds = null, cozySwapSlot = -1;
    var cozyDisplayKeys = Array.prototype.map.call(document.querySelectorAll('.apparel-cart-item'), function(el) { return el.getAttribute('data-key'); });

    /* Update the color name label and image immediately */
    var cartItem = swatch.closest('.apparel-cart-item');
    if (cartItem) {
      var colorName = cartItem.querySelector('.apparel-cart-item__color-name');
      if (colorName && newColor) colorName.textContent = newColor;
      /* Update active swatch visually */
      cartItem.querySelectorAll('.apparel-cart-item__swatch').forEach(function(s) {
        s.classList.remove('apparel-cart-item__swatch--active');
      });
      swatch.classList.add('apparel-cart-item__swatch--active');

      /* Disable swatches during swap to prevent double-tap */
      cartItem.querySelectorAll('.apparel-cart-item__swatch').forEach(function(s) {
        s.style.pointerEvents = 'none';
      });

      /* Update the product image to match the selected color — preload to prevent flash */
      var handle = cartItem.getAttribute('data-product-handle');
      function swapCartItemImage(product) {
        var newImgSrc = findImageForVariant(product, parseInt(newVariantId, 10), newColor);
        if (newImgSrc) {
          var imgEl = cartItem.querySelector('.apparel-cart-item__image img');
          if (imgEl) {
            var finalSrc = newImgSrc.replace(/(\.\w+)(\?.*)?$/, '_200x$1');
            var preload = new Image();
            preload.onload = function() { imgEl.src = finalSrc; };
            preload.src = finalSrc;
          }
        }
      }
      if (handle && productDataCache[handle]) {
        swapCartItemImage(productDataCache[handle]);
      } else if (handle) {
        fetchProductData(handle).then(swapCartItemImage);
      }
    }

    /* Get the current variant ID from the cart item data attribute */
    var currentVariantId = cartItem ? cartItem.getAttribute('data-variant-id') : null;

    /* Personalization (engraved names, chain length) must survive the colour swap.
       Read it from the LIVE cart at swap time - any in-memory copy can go stale
       once a swap re-keys the line, and stale props ship a nameless necklace. */
    var cozyCarriedProps = cozyLinePropsByKey[itemKey] || {};
    var cozyHasProps = Object.keys(cozyCarriedProps).length > 0;

    /*
     * Use /cart/change.js to remove old variant first, then /cart/change.js
     * to set new variant quantity. Avoids /cart/add.js which triggers
     * Shopify Dawn's cart-notification interceptor and causes duplicates.
     */
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(liveCart) {
      for (var lc = 0; lc < liveCart.items.length; lc++) {
        if (liveCart.items[lc].key === itemKey) {
          cozyCarriedProps = liveCart.items[lc].properties || {};
          cozyHasProps = Object.keys(cozyCarriedProps).length > 0;
          break;
        }
      }
      /* Order must come from what the shopper SEES (the DOM), not the cart
         array — Shopify's array order diverges from the displayed order after
         the first stable-ordered render. */
      var cozyIdByKey = {};
      liveCart.items.forEach(function(ci) { cozyIdByKey[ci.key] = cozyLineIdentity(ci); });
      cozyPrevIds = [];
      cozyDisplayKeys.forEach(function(k) { if (cozyIdByKey[k]) cozyPrevIds.push(cozyIdByKey[k]); });
      if (cozyPrevIds.length === liveCart.items.length) {
        cozySwapSlot = cozyDisplayKeys.indexOf(itemKey);
      } else {
        /* DOM stale vs live cart — fall back to cart order */
        cozyPrevIds = liveCart.items.map(cozyLineIdentity);
        for (var ps = 0; ps < liveCart.items.length; ps++) {
          if (liveCart.items[ps].key === itemKey) { cozySwapSlot = ps; break; }
        }
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      /* Check if the new variant already exists in cart after removing old one */
      var existingItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(newVariantId)) {
          existingItem = cart.items[i];
          break;
        }
      }
      /* 🔒 NEVER MERGE (TA 2026-08-11): a drawer swap must never fold this line
         into another cart line — each line stays individually editable. If Shopify
         would auto-merge (identical variant + identical properties), stamp a hidden
         _keep property so the line keeps its own identity. */
      var cozySwapProps = cozyCarriedProps || {};
      if (existingItem && JSON.stringify(existingItem.properties || {}) === JSON.stringify(cozySwapProps)) {
        cozySwapProps = Object.assign({}, cozySwapProps);
        cozySwapProps._keep = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      }
      return xhrCartAdd(parseInt(newVariantId, 10), quantity, cozySwapProps);
    })
    .then(function(r) { return r && r.json ? r.json() : r; })
    .then(function() {
      swatchSwapping = false;
      /* Stable full re-render (replaces the old one-card soft update): Shopify
         re-hashes EVERY line key on any mutation, so patching one card left the
         OTHER lines holding dead keys — their next click then misfired. A full
         render refreshes every key; cozyStableOrder keeps the visual order. */
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cozyStableOrder(cart, cozyPrevIds, cozySwapSlot));
        });
    })
    .catch(function(err) {
      console.error('Swatch swap error:', err);
      swatchSwapping = false;
      refreshCartDrawer();
    });
  }

  function handleCartSizeClick(sizeBtn) {
    if (swatchSwapping) return;
    var newVariantId = sizeBtn.getAttribute('data-variant-id');
    var itemKey = sizeBtn.getAttribute('data-item-key');
    var quantity = parseInt(sizeBtn.getAttribute('data-quantity') || '1', 10);
    var newSize = sizeBtn.getAttribute('data-size');
    if (!newVariantId || !itemKey) return;
    if (sizeBtn.classList.contains('apparel-cart-item__size-btn--active')) return;

    swatchSwapping = true;
    var cozyPrevIds = null, cozySwapSlot = -1;
    var cozyDisplayKeys = Array.prototype.map.call(document.querySelectorAll('.apparel-cart-item'), function(el) { return el.getAttribute('data-key'); });

    var cartItem = sizeBtn.closest('.apparel-cart-item');
    if (cartItem) {
      /* Update size name label */
      var sizeName = cartItem.querySelector('.apparel-cart-item__size-name');
      if (sizeName && newSize) sizeName.textContent = newSize;
      /* Update active size button */
      cartItem.querySelectorAll('.apparel-cart-item__size-btn').forEach(function(b) {
        b.classList.remove('apparel-cart-item__size-btn--active');
        b.style.pointerEvents = 'none';
      });
      sizeBtn.classList.add('apparel-cart-item__size-btn--active');
    }

    /* Personalization must survive the size swap too */
    var cozySizeCarriedProps = cozyLinePropsByKey[itemKey] || {};
    var cozySizeHasProps = Object.keys(cozySizeCarriedProps).length > 0;

    /* Same variant swap as swatch click: remove old variant, add new.
       Props read from the LIVE cart first - see colour-swap note above. */
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(liveCart) {
      for (var lc = 0; lc < liveCart.items.length; lc++) {
        if (liveCart.items[lc].key === itemKey) {
          cozySizeCarriedProps = liveCart.items[lc].properties || {};
          cozySizeHasProps = Object.keys(cozySizeCarriedProps).length > 0;
          break;
        }
      }
      /* Order must come from what the shopper SEES (the DOM), not the cart
         array — Shopify's array order diverges from the displayed order after
         the first stable-ordered render. */
      var cozyIdByKey = {};
      liveCart.items.forEach(function(ci) { cozyIdByKey[ci.key] = cozyLineIdentity(ci); });
      cozyPrevIds = [];
      cozyDisplayKeys.forEach(function(k) { if (cozyIdByKey[k]) cozyPrevIds.push(cozyIdByKey[k]); });
      if (cozyPrevIds.length === liveCart.items.length) {
        cozySwapSlot = cozyDisplayKeys.indexOf(itemKey);
      } else {
        /* DOM stale vs live cart — fall back to cart order */
        cozyPrevIds = liveCart.items.map(cozyLineIdentity);
        for (var ps = 0; ps < liveCart.items.length; ps++) {
          if (liveCart.items[ps].key === itemKey) { cozySwapSlot = ps; break; }
        }
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var existingItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(newVariantId)) {
          existingItem = cart.items[i];
          break;
        }
      }
      /* 🔒 NEVER MERGE (TA 2026-08-11) — see colour-swap note above. */
      var cozySizeSwapProps = cozySizeCarriedProps || {};
      if (existingItem && JSON.stringify(existingItem.properties || {}) === JSON.stringify(cozySizeSwapProps)) {
        cozySizeSwapProps = Object.assign({}, cozySizeSwapProps);
        cozySizeSwapProps._keep = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      }
      return xhrCartAdd(parseInt(newVariantId, 10), quantity, cozySizeSwapProps);
    })
    .then(function(r) { return r && r.json ? r.json() : r; })
    .then(function() {
      swatchSwapping = false;
      /* Full re-render in the PRE-swap display order — see cozyStableOrder */
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cozyStableOrder(cart, cozyPrevIds, cozySwapSlot));
        });
    })
    .catch(function(err) {
      console.error('Size swap error:', err);
      swatchSwapping = false;
      refreshCartDrawer();
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); updateCartCount(); })
      .catch(function(err) { console.error('Cart update error:', err); });
  }

  function updateCartCount(count) {
    /* Re-render the header cart-icon-bubble section so the count badge is
       created/removed and the empty<->full cart icon swaps correctly, even
       when the page loaded with an empty cart. Authoritative from the server. */
    fetch('/?sections=cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var markup = data && data['cart-icon-bubble'];
        if (!markup) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = markup;
        var fresh = tmp.querySelector('#shopify-section-cart-icon-bubble') || tmp.firstElementChild;
        var icon = document.getElementById('cart-icon-bubble');
        if (icon && fresh) icon.innerHTML = fresh.innerHTML;
      })
      .catch(function() {});
  }

  function startTimer() {
    var timerEl = document.getElementById('apparel-cart-timer-value');
    if (!timerEl) return;
    var minutes = 10, seconds = 0;
    setInterval(function() {
      if (seconds === 0) { if (minutes === 0) return; minutes--; seconds = 59; } else { seconds--; }
      timerEl.textContent = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }, 1000);
  }

  function handleStickyBar() {
    if (!stickyBar || !form) return;
    var formRect = form.getBoundingClientRect();
    if (formRect.bottom < 0) stickyBar.classList.add('apparel-sticky-bar--visible');
    else stickyBar.classList.remove('apparel-sticky-bar--visible');
  }

  /* ═══════════════════════════════════════════
     EVENT BINDINGS
     ═══════════════════════════════════════════ */

  document.querySelectorAll('.apparel-product__color-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      var optIndex = this.getAttribute('data-option-index');
      document.querySelectorAll('.apparel-product__color-swatch[data-option-index="' + optIndex + '"]')
        .forEach(function(s) { s.classList.remove('apparel-product__color-swatch--active'); });
      this.classList.add('apparel-product__color-swatch--active');
      updateVariant();
    });
  });

  document.querySelectorAll('.apparel-product__size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var optIndex = this.getAttribute('data-option-index');
      document.querySelectorAll('.apparel-product__size-btn[data-option-index="' + optIndex + '"]')
        .forEach(function(b) { b.classList.remove('apparel-product__size-btn--active'); });
      this.classList.add('apparel-product__size-btn--active');
      apparelHideSizeError();
      updateVariant();
    });
  });

  if (prevArrow) {
    prevArrow.addEventListener('click', function() { scrollGalleryBy(-getSlideStep()); });
  }
  if (nextArrow) {
    nextArrow.addEventListener('click', function() { scrollGalleryBy(getSlideStep()); });
  }

  if (thumbnails) {
    thumbnails.addEventListener('click', function(e) {
      var thumb = e.target.closest('.apparel-product__thumbnail');
      if (!thumb) return;
      var globalIndex = parseInt(thumb.getAttribute('data-index'), 10);
      showGalleryImageByGlobalIndex(globalIndex);
    });
  }

  if (dotsContainer) {
    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.apparel-product__gallery-dot');
      if (!dot) return;
      var dotIndex = parseInt(dot.getAttribute('data-dot-index'), 10);
      scrollToVisibleIndex(dotIndex, true);
      highlightVisibleThumb(dotIndex);
      updateDotActive(dotIndex);
    });
  }

  if (galleryMain) {
    galleryMain.addEventListener('click', function(e) {
      var imageDiv = e.target.closest('.apparel-product__gallery-image');
      if (!imageDiv) return;
      /* Don't zoom the video slide — let the user watch/scrub it instead. */
      if (imageDiv.classList.contains('apparel-product__gallery-image--video')) return;
      if (imageDiv.classList.contains('apparel-product__gallery-image--zoomed')) {
        imageDiv.classList.remove('apparel-product__gallery-image--zoomed');
      } else {
        galleryMain.querySelectorAll('.apparel-product__gallery-image--zoomed')
          .forEach(function(el) { el.classList.remove('apparel-product__gallery-image--zoomed'); });
        imageDiv.classList.add('apparel-product__gallery-image--zoomed');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var zoomed = document.querySelector('.apparel-product__gallery-image--zoomed');
        if (zoomed) zoomed.classList.remove('apparel-product__gallery-image--zoomed');
      }
    });

    var scrollSyncRaf;
    galleryMain.addEventListener('scroll', function() {
      if (scrollSyncRaf) cancelAnimationFrame(scrollSyncRaf);
      scrollSyncRaf = requestAnimationFrame(function() {
        syncScrollToSlideIndex();
        updateArrowState();
      });
    }, { passive: true });

    /* Autoplay the product video slide only while it's on screen (smooth on iOS, saves data). */
    var galleryVideo = galleryMain.querySelector('.apparel-product__gallery-image--video video');
    if (galleryVideo && 'IntersectionObserver' in window) {
      var galleryVideoIO = new IntersectionObserver(function(entries) {
        entries.forEach(function(en) {
          if (en.isIntersecting && en.intersectionRatio > 0.5) {
            var pr = galleryVideo.play();
            if (pr && pr.catch) { pr.catch(function() {}); }
          } else {
            galleryVideo.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] });
      galleryVideoIO.observe(galleryVideo);
    }
  }

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!apparelRequireSize()) return;
      var variantId = variantSelect ? variantSelect.value : null;
      if (variantId) addToCart(variantId, 1);
    }, true);
  }
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function() {
      if (!apparelRequireSize()) return;
      var variantId = variantSelect ? variantSelect.value : null;
      if (variantId) addToCart(variantId, 1);
    });
  }
  if (cartClose) { cartClose.addEventListener('click', closeCartDrawer); }

  /* Intercept Shopify header cart icon to open our custom drawer */
  var headerCartIcon = document.getElementById('cart-icon-bubble');
  if (headerCartIcon) {
    headerCartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      refreshCartDrawer();
      openCartDrawer();
    });
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', function(e) {
      if (e.target === cartOverlay) closeCartDrawer();
    });
  }
  document.addEventListener('click', function(e) {
    if (cartDrawer && cartDrawer.classList.contains('apparel-cart-drawer--open') &&
        !cartDrawer.contains(e.target) && e.target !== cartOverlay) {
      closeCartDrawer();
    }
  });
  var continueShoppingBtn = document.querySelector('.apparel-cart-continue');
  if (continueShoppingBtn) { continueShoppingBtn.addEventListener('click', closeCartDrawer); }
  if (cartLineItems) { cartLineItems.addEventListener('click', handleCartItemClick); }

  /* Expose cart drawer controls globally so other sections (e.g. recommendations) can open the drawer */
  window.ApparelCart = window.ApparelCart || {};
  window.ApparelCart.open = openCartDrawer;
  window.ApparelCart.refresh = refreshCartDrawer;
  window.ApparelCart.openAndRefresh = function() {
    refreshCartDrawer();
    openCartDrawer();
  };
  window.addEventListener('scroll', handleStickyBar, { passive: true });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('apparel-cart-drawer--open')) {
      closeCartDrawer();
    }
  });

  var resizeDebounce;
  window.addEventListener('resize', function() {
    clearTimeout(resizeDebounce);
    resizeDebounce = setTimeout(function() {
      buildDots();
      updateArrowState();
    }, 200);
  });

  /* Size Guide Modal */
  var sizeGuideBtn = document.querySelector('[data-size-guide]');
  var sizeGuideModal = document.getElementById('apparel-size-guide-modal');
  var sizeGuideOverlay = document.getElementById('apparel-size-guide-overlay');
  var sizeGuideClose = document.getElementById('apparel-size-guide-close');

  function openSizeGuide() {
    if (sizeGuideModal) sizeGuideModal.classList.add('apparel-size-guide-modal--open');
    if (sizeGuideOverlay) sizeGuideOverlay.classList.add('apparel-size-guide-overlay--open');
  }
  function closeSizeGuide() {
    if (sizeGuideModal) sizeGuideModal.classList.remove('apparel-size-guide-modal--open');
    if (sizeGuideOverlay) sizeGuideOverlay.classList.remove('apparel-size-guide-overlay--open');
  }
  if (sizeGuideBtn) {
    sizeGuideBtn.addEventListener('click', function(e) { e.preventDefault(); openSizeGuide(); });
  }
  if (sizeGuideClose) { sizeGuideClose.addEventListener('click', closeSizeGuide); }
  if (sizeGuideOverlay) { sizeGuideOverlay.addEventListener('click', closeSizeGuide); }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sizeGuideModal && sizeGuideModal.classList.contains('apparel-size-guide-modal--open')) closeSizeGuide();
  });

  /* ═══════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════ */
  (function init() {
    if (galleryMain) {
      currentVisibleImages = Array.from(
        galleryMain.querySelectorAll('.apparel-product__gallery-image')
      );
    }
    if (thumbnails) {
      currentVisibleThumbs = Array.from(
        thumbnails.querySelectorAll('.apparel-product__thumbnail')
      );
    }

    /* Filter to the initially selected color on page load */
    if (colorOptionIndex >= 0) {
      var activeSwatch = document.querySelector(
        '.apparel-product__color-swatch--active[data-option-index="' + colorOptionIndex + '"]'
      );
      if (activeSwatch) {
        var initialColor = activeSwatch.getAttribute('data-value');
        if (initialColor) filterGalleryByColor(initialColor);
      }
    }

    if (currentColorFilter === null) showAllImages();

    updateCartCount();
    startTimer();
    buildDots();
    updateArrowState();
  })();
})();

